<template>
    <div>
        <Head title="Створити озеро"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('lakes.index')"
            >
                Озеро
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Створення озера
        </h1>
        <div
            class="rounded-md shadow overflow-hidden"
            :class="{ 'max-w-full': isFormFullWidth, 'max-w-3xl bg-white': !isFormFullWidth }"
        >
            <form @submit.prevent="store">
                <div class="flex flex-wrap">
                    <div
                        class="flex flex-wrap mb-8 -mr-6 p-8"
                        :class="{'max-w-3xl rounded-md border-2 border-b-0 bg-white': isFormFullWidth}"
                    >
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Базова ціна за місце"/>
                        <text-input v-model="form.price_per_person" :error="form.errors.price_per_person" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна за одну людину"/>
                        <text-input v-model="form.latitude" :error="form.errors.latitude"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Широта"/>
                        <text-input v-model="form.longitude" :error="form.errors.longitude"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="Довгота"/>
                        <text-input v-model="form.public_liq_pay_key" :error="form.errors.public_liq_pay_key"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="LiqPay public key"/>
                        <text-input v-model="form.private_liq_pay_key" :error="form.errors.private_liq_pay_key"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="LiqPay private key"/>
                        <textarea-input v-model="form.short_description" :error="form.errors.short_description"
                                        class="pb-8 pr-6 w-full" label="Короткий опис"/>
                        <div class="pb-8 pr-6 w-full">
                            <label class="form-label" for="description">Опис</label>
                            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                      id="description" class="description"/>
                        </div>
                        <text-input v-model="form.price_depend_on_category" type="checkbox"
                                    :error="form.errors.price_depend_on_category"
                                    class="pb-8 pr-6 w-full admin-input-with-checkbox" label="Ціна залежить від тарифу рибалки"/>
                        <text-input v-model="form.price_depend_on_people_count" type="checkbox"
                                    :error="form.errors.price_depend_on_people_count"
                                    class="pb-8 pr-6 w-full" label="Ціна залежить від кількості людей"/>
                        <text-input v-model="form.price_depend_on_day_of_week" type="checkbox"
                                    :error="form.errors.price_depend_on_day_of_week"
                                    class="pb-8 pr-6 w-full" label="Ціна залежить від дня тижня"/>
                        <text-input v-model="form.is_active" type="checkbox"
                                    :error="form.errors.is_active"
                                    class="pb-8 pr-6 w-full" label="Озеро активне"/>

                        <drag-and-drop
                            v-model="form.image"
                            :error="form.errors.image"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            type="file"
                            accept="image/*"
                            label="Зображення"
                        />
                    </div>
                    <div
                        class="mb-8 -mr-6 p-8"
                        :class="{'max-w-3xl rounded-md border-2 border-b-0 bg-white': isFormFullWidth}"
                    >
                        <div v-if="isPriceDependOnDayOfWeek" class="flex flex-wrap">
                            <text-input v-model="form.monday_price" :error="form.errors.monday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф понедельник"/>
                            <text-input v-model="form.tuesday_price" :error="form.errors.tuesday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф вторник"/>
                            <text-input v-model="form.wednesday_price" :error="form.errors.wednesday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф среда"/>
                            <text-input v-model="form.thursday_price" :error="form.errors.thursday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф четверг"/>
                            <text-input v-model="form.friday_price" :error="form.errors.friday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф пятница"/>
                            <text-input v-model="form.saturday_price" :error="form.errors.saturday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф суббота"/>
                            <text-input v-model="form.sunday_price" :error="form.errors.sunday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф восресенье"/>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити озеро
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from "@/Shared/FileInput"
import DragAndDrop from "@/Shared/DragAndDrop"
import checkbox from "@/Shared/Checkbox"
import TextareaInput from "@/Shared/TextareaInput"
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        ckeditor: CKEditor.component
    },
    layout: Layout,
    props: {
        lakes: Array,
    },
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                name: '',
                price: null,
                price_per_person: null,
                latitude: '',
                longitude: '',
                lake_id: null,
                number: '',
                description: '',
                image: '',
                public_liq_pay_key: '',
                private_liq_pay_key: '',
                price_depend_on_category: false,
                price_depend_on_people_count: false,
                price_depend_on_day_of_week: false,
                is_active: false,
                monday_price: 1,
                tuesday_price: 1,
                wednesday_price: 1,
                thursday_price: 1,
                friday_price: 1,
                saturday_price: 1,
                sunday_price: 1,
            }),
        }
    },
    computed: {
        checkbox() {
            return checkbox
        },
        isFormFullWidth() {
            return this.form.price_depend_on_day_of_week
        },
        isPriceDependOnCategory() {
            return this.form.price_depend_on_category
        },
        isPriceDependOnPeopleCount() {
            return this.form.price_depend_on_people_count
        },
        isPriceDependOnDayOfWeek() {
            return this.form.price_depend_on_day_of_week
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('lakes.store'))
        },
    },
}
</script>
<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 500px;
}
.description {
    width: 100%;
    min-width: 100%;
}
</style>
